import { IAvailableAppointmentDateResponse } from "@modules/eirCustomersFacade/interfaces/responses/IAvailableAppointmentDateResponse";
import {
    ETimeSlot,
    IAvailableAppointmentDate,
} from "@modules/eirCustomersFacade/interfaces/models/IAvailableAppointmentDate";

const convertSlotCodesToLabels = (slotCodes: string[]): ETimeSlot[] => {
    const codeToEnum: Record<string, ETimeSlot> = {
        AM: ETimeSlot.AM,
        PM: ETimeSlot.PM,
        AD: ETimeSlot.AD,
    };

    const slotLabels: ETimeSlot[] = [];

    slotCodes.forEach((code) => {
        slotLabels.push(codeToEnum[code]);
    });

    return slotLabels;
};

export const mapAvailableAppointmentDate = (
    response: IAvailableAppointmentDateResponse
): IAvailableAppointmentDate => ({
    scheduledDate: response.scheduledDate,
    timeSlotList: convertSlotCodesToLabels(response.timeSlots),
});
